module.exports = __webpack_public_path__ + "img/circle-nodes-solid.84d3e031.svg";